<div class="flight container" [ngClass]="{ 'has-lowest-fare': hasLowestPrice, 'has-last-seats': hasLastSeats }">
    <div class="grid align-items-center">
        <div class="col col-6 col-p-12">
            <app-flight-details [flight]="flight" [showAirplane]="true" class="is-flights-page"></app-flight-details>
        </div>

        <div [ngClass]="{ 'col-3 col-p-6': brandsList.length === 2, 'col-6 col-p-12': brandsList.length === 1 }" *ngFor="let brand of brandsList; let index = index" class="flight-buttons__wrapper button-cabin">

            <button *ngIf="INDRA_checkAvailability(index); else notAvailable" (click)="INDRA_selectCabin(index, $event)" class="flight__cabin" [ngClass]="{ selected: (selected_cabin === index) && showDetails, 'is-one': brandsList.length === 1 }" [attr.aria-label]=INDRA_printAriaLabel(brand)
                [attr.aria-expanded]="(selected_cabin === index) && showDetails" [attr.aria-controls]="'flight-brand-' + flight.id + '-' + index">

				<app-lowest-fare 
					class="lowest-fare" 
					*ngIf="INDRA_isLowestFare(brand)">
				</app-lowest-fare>
				
				<app-alert-label 
					[isMobile]="isMobile" 
					class="last-seats" 
					[ngClass]="{ 'last-seats-anchor': !longLSM, 'last-seats-anchor-long': longLSM}"
					text="Last seats. Hurry!" 
					*ngIf="INDRA_isLastSeat(brand)">
				</app-alert-label>
				
				<div class="flight__cabin-wrapper" aria-hidden="true">
					<div class="flight__cabin-left">
						<strong skeletonLoader [translationKey]="INDRA_getLabel(brand.label)" [innerHTML]="INDRA_printLabel(brand.label)">
						</strong>
						<p>
							<span skeletonLoader [translationKey]="'availability.flightsPage.text.' + brand.label_sufix">
								{{'availability.flightsPage.text.' + brand.label_sufix | ibeadmin |async}}
							</span>
						</p>
					</div>
					<div class="flight__cabin-right" *ngIf="INDRA_getLowestAAMOriginalPrice(brand.brands); else milesAndGoDiscount">
						<p class="price price--original">
							{{ INDRA_getLowestAAMOriginalPrice(brand.brands).toString() | indracurrency }}
							<span *ngIf="!bookAwardFlight"> {{ currency }}</span> 
							<span *ngIf="bookAwardFlight"> {{ INDRA_getTax(brand.brands) }} </span>
						</p>
						<p class="price">
							{{ INDRA_finalPrice(brand.brands) | indracurrency }} 
							<span *ngIf="!bookAwardFlight">
								{{ currency }}
							</span> 
							<span *ngIf="bookAwardFlight"> {{ INDRA_getTax(brand.brands) }} </span>
						</p>
					</div>
					<ng-template #milesAndGoDiscount>
						<div class="flight__cabin-right" *ngIf="isLoggedIn; else originalPriceOnly">
							<p *ngIf="milesInfo === 'cash' && discountMiles && flight.milesGoDiscount && brand.brands" class="price price--original">
								{{ INDRA_printLowestPrice(brand.brands).toString() | indracurrency }}
								<span *ngIf="!bookAwardFlight"> {{ currency }}</span> 
								<span *ngIf="bookAwardFlight"> {{ INDRA_getTax(brand.brands) }} </span>
							</p>
							<p class="price">
								{{ INDRA_finalPrice(brand.brands) | indracurrency }} 
								<span *ngIf="!bookAwardFlight">
									{{ currency }}
								</span> 
								<span *ngIf="bookAwardFlight"> {{ INDRA_getTax(brand.brands) }} </span>
							</p>
						</div>
						<ng-template #originalPriceOnly>
							<div class="flight__cabin-right">
								<p class="price">
									{{ INDRA_finalPrice(brand.brands) | indracurrency }} 
									<span *ngIf="!bookAwardFlight">
										{{ currency }}
									</span> 
									<span *ngIf="bookAwardFlight"> {{ INDRA_getTax(brand.brands) }} </span>
								</p>
							</div>
						</ng-template>
					</ng-template>
				</div>
			</button>

            <ng-template #notAvailable>
                <button class="flight__cabin disabled" [ngClass]="{'is-one': brandsList.length === 1 }" [attr.aria-label]="brand.label + ' ' + ('availability.flightsPage.aria.flightSoldOut' | ibeadmin | async) ">
					<div class="flight__cabin-wrapper" aria-hidden="true">
						<div class="flight__cabin-left">
							<strong skeletonLoader [translationKey]="INDRA_getLabel(brand.label)" [innerHTML]="INDRA_printLabel(brand.label)">
							</strong>
						</div>
						<div class="flight__cabin-right">
							<p class="text-right">
								<span skeletonLoader [translationKey]="'availability.flightsPage.text.' + INDRA_getMessage(brand)">
									{{'availability.flightsPage.text.' + INDRA_getMessage(brand)| ibeadmin |async}}
								</span>
							</p>
						</div>
					</div>
				</button>
            </ng-template>
        </div>
        <div class="col-12" *ngIf="INDRA_isLowestPriceUpdated()">
            <div class="flight-note__wrapper">
                <div class="flight-note" [ngClass]="{'lowest-extra-padding': hasLastSeats}">
                    <app-svg class="flight-note__icon" svg="icons.svg#general--timer" alt="Price change information icon" aria-hidden="true"></app-svg>
					<span skeletonLoader [translationKey]="'availability.flightsPage.text.lowestPriceWasUpdated'">
						{{'availability.flightsPage.text.lowestPriceWasUpdated' | ibeadmin | async}}
					</span>
                </div>
            </div>
        </div>
    </div>

    <app-expand-collapse [state]="INDRA_brandsState" class="flight-brands__wrapper" [ngClass]="{'is-expanded': INDRA_brandsState === 'expanded'}">
        <ng-container *ngFor="let list of brandsList; let listIndex = index">

            <div *ngIf="INDRA_showBrands(listIndex)" class="grid" role="radiogroup" [attr.id]="'flight-brand-' + flight.id + '-' + listIndex">
                <!-- <div class="col-p-12 col-6 flight-brand-extra" *ngIf="list.brands.length === 1 && INDRA_displayFlightSelectionImage()">
                    <app-svg aria-hidden="true" style="width: 100%;" class="top-gap" svg="sprite.svg#illustration--flight_selection" [alt]="'availability.flightsPage.alt.flightSelectionIllustration' | ibeadmin | async"></app-svg>
                </div> -->
                <div [ngClass]="INDRA_brandsStyles(listIndex)" *ngFor="let brand of list.brands; let brandIndex = index">
					<app-brand 
						[ngClass]="{'is-selected': INDRA_isSelected(brandIndex)}"
						[class]="'brand brand__wrapper--' + brand.name" 
						[ngClass]="{'is-selected': selected_brand !== undefined && brandIndex === selected_brand}"
						[brand]="INDRA_getBrand(listIndex, brandIndex)" 
						[economyxtra]="INDRA_isEconomyExtra(listIndex, brandIndex)" 
						[otherBrandHasEconomyExtra]="INDRA_hasBrandsWithEconomyExtra(listIndex)"
                        (clickFeature)="INDRA_handleDetailsFeature($event, brand)" 
						(selectConfirm)="INDRA_selectConfirmBrand(brandIndex)" 
						(selected)="INDRA_selectBrand(brandIndex)" 
						[selectedBrand]="selectedBrandName" 
						[ancillariesList]="INDRA_getAncillaries(listIndex, brandIndex)" 
						[includedAncillaries]="INDRA_getIncludedAncillaries(listIndex, brandIndex)"
                        [milesGoDiscount]="flight.milesGoDiscount" 
						[milesTobeEarned]="INDRA_getMilesToBeEarned(listIndex, brandIndex)"
						[isLoggedIn]="isLoggedIn">
                    </app-brand>
                </div>
                <!-- <div class="col-12" *ngIf="INDRA_hasBrandsWithEconomyExtra(listIndex) && isTAPCarrier && flight.listSegment.length >= 1">
					<app-upsell-economyxtra  [flight]="flight" [brands]="list.brands"></app-upsell-economyxtra >
				</div> -->
                <!-- <div class="col-12">
                    <a (click)="INDRA_openCompareFares(listIndex)" [attr.aria-label]="'availability.flightsPage.aria.openDialog' | ibeadmin | async" class="link" href="javascript:;" role="button">
						{{'availability.flightsPage.text.compareFares' | ibeadmin |async}}
					</a>
                </div> -->
                <div class="col-12" style="padding-top: 3rem;">
                    <div class="flight-note muted" *ngIf="INDRA_showWarning(0)">
                        <app-svg class="flight-note__icon" svg="icons.svg#general--information" [alt]="'availability.flightsPage.alt.informationIcon' | ibeadmin | async" aria-hidden="true">
                        </app-svg>
						<span skeletonLoader [translationKey]="'availability.flightsPage.text.oneFlightIsFullEconomy'">
							{{'availability.flightsPage.text.oneFlightIsFullEconomy' | ibeadmin |async}} ({{economyFlightSegmentNumbers}}).
						</span>
                    </div>
                    <div class="flight-note muted" *ngIf="INDRA_showWarning(1)">
                        <app-svg class="flight-note__icon" svg="icons.svg#general--information" [alt]="'availability.flightsPage.alt.informationIcon' | ibeadmin | async" aria-hidden="true">
                        </app-svg>
                        <span skeletonLoader [translationKey]="'availability.flightsPage.text.onBoardServicesAndBaggageNotGuaranteed'">
							{{'availability.flightsPage.text.onBoardServicesAndBaggageNotGuaranteed' | ibeadmin |async}}
						</span>
                    </div>

                    <ng-container *ngIf="bookAwardFlight && flightFilter.starAlliance">
                        <div class="flight-note muted" *ngIf="starAwardsFlightMixedWithEconomy">
                            <app-svg class="flight-note__icon" svg="icons.svg#general--information" [alt]="'availability.flightsPage.alt.informationIcon' | ibeadmin | async" aria-hidden="true">
                            </app-svg>
							<span skeletonLoader [translationKey]="'availability.flightsPage.text.starOneFlightIsEconomy'">
								{{'availability.flightsPage.text.starOneFlightIsEconomy' | ibeadmin |async}}
							</span>
                        </div>
                        <div class="flight-note muted" *ngIf="starAwardsFlightMixedWithExecutive">
                            <app-svg class="flight-note__icon" svg="icons.svg#general--information" [alt]="'availability.flightsPage.alt.informationIcon' | ibeadmin | async" aria-hidden="true">
                            </app-svg>
							<span skeletonLoader [translationKey]="'availability.flightsPage.text.starOneFlightIsExecutive'">
								{{'availability.flightsPage.text.starOneFlightIsExecutive' | ibeadmin |async}}
							</span>
                        </div>
                    </ng-container>

                    <app-notification [style]="'note'" [icon]="'icons.svg#luggage--forbiden'" [title]="'Extra Baggage Not Allowed'" *ngIf="INDRA_showWarning(2)">
                        <div message>
                            <span skeletonLoader [translationKey]="'availability.flightsPage.text.passengersNotAllowedExtraBaggage'">
								{{'availability.flightsPage.text.passengersNotAllowedExtraBaggage' | ibeadmin |async}}<br>
								{{'availability.flightsPage.text.youCanOnlyCarry' | ibeadmin |async}}

							</span>
                            <a class="link link--external padding-left-gap" href="javascript:;" (click)="INDRA_openUrl('externalURLs.notAllowedExtraBaggageInfo')" role="button" [attr.aria-label]="'availability.flightsPage.aria.goTolearnMore' | ibeadmin | async" aria-hidden="true"
                                [tooltip]="'availability.flightsPage.tooltip.notAllowedExtraBaggage' | ibeadmin | async">
								<span skeletonLoader [translationKey]="'availability.flightsPage.text.learnMore'">
									{{ 'availability.flightsPage.text.learnMore' | ibeadmin | async}}
								</span>
							</a>
                        </div>
                    </app-notification>
                    <div class="flight-note muted" *ngIf="INDRA_showWarning(3)">
                        <app-svg class="flight-note__icon" svg="icons.svg#general--information" [alt]="'availability.flightsPage.alt.informationIcon' | ibeadmin | async" aria-hidden="true">
                        </app-svg>
                        <span>
							<span skeletonLoader [translationKey]="'availability.flightsPage.text.extraBaggageCantBePurchased'">
								{{ 'availability.flightsPage.text.extraBaggageCantBePurchased' | ibeadmin | async}}
								{{INDRA_formatEmbargoDate(flightInfo.embargoStartDate)}}
								{{ 'availability.flightsPage.text.and' | ibeadmin | async}}
								{{INDRA_formatEmbargoDate(flightInfo.embargoEndDate)}}.
							</span>
							<a
								class="link link--external padding-left-gap"
								href="javascript:;" 
								(click)="INDRA_openUrl('externalURLs.alertAndInformation')"
								role="button"
								[attr.aria-label]="'availability.flightsPage.aria.goTolearnMore' | ibeadmin | async"
								aria-hidden="true"
							>
								<span skeletonLoader [translationKey]="'availability.flightsPage.text.learnMore'">
									{{ 'availability.flightsPage.text.learnMore' | ibeadmin | async}}
								</span>
							</a>
						</span>
                    </div>
					<div class="flight-note muted" *ngIf="INDRA_showWarning(4)">
                        <app-svg class="flight-note__icon" svg="icons.svg#general--information" [alt]="'availability.flightsPage.alt.informationIcon' | ibeadmin | async" aria-hidden="true">
                        </app-svg>
                        <span skeletonLoader [translationKey]="'availability.flightsPage.text.flightWillBeEconomy'">
							{{'availability.flightsPage.text.flightWillBeEconomy' | ibeadmin |async}}
						</span>
                    </div>
                </div>
                <!-- <div class="col-6">
					<app-expand-collapse [state]="INDRA_nextStepState" [attr.aria-hidden]="this.selected_brand === undefined">
						<div class="flight__confirm">
							<div class="flight__confirm-text">
								<strong>Flight</strong> <em> for {{ n_passengers }} pax </em>
								<strong> —
									{{bookAwardFlight?INDRA_bookAwardPrice(flight_total):flight_total }}{{ currency }}</strong>
								<div class="price_breakdown">
									<a class="link" *ngIf="INDRA_changeFlight()" (click)="INDRA_handlePriceBreakDown()" aria-label="Open a new window to show price breakdown" href="javascript:;" role="button">Price breakdown</a>
								</div>
							</div>
							<div class="flight__confirm-actions">
								<div class="time-to-think__card" *ngIf="INDRA_handleTimeToThink()">
									<div class="time-to-think__card-text">
										<span class="time-to-think__card-text-label">Save this price for 48 hours</span>
										<span>40€ per booking</span>
									</div>
									<div class="time-to-think__card-check">
										<app-checkbox-input [label]="''" id="time-to-think" (change)="INDRA_timeToThinkChanges()" [checked]="timeToThink">
										</app-checkbox-input>
									</div>
								</div>
								<button class="button button-accent button--icon-right" (click)="INDRA_handleSelectFlight()">{{ INDRA_printSelectButtonLabel()}}
									<app-svg svg="icons.svg#general--arrow--right" aria-hidden="true" [alt]="'Arrow icon'"></app-svg>
								</button>
							</div>
						</div>
					</app-expand-collapse>
				</div> -->
            </div>
        </ng-container>
    </app-expand-collapse>
</div>

<div class="divider"></div>
